import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/step2.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')